import React  from 'react';
import NextButton from '../../components/nextButton';
import styled, { keyframes } from 'styled-components';
import { fadeInRight } from 'react-animations';

import './style.css';  //  !!!

const KeyText = styled.span`
  color: #00fcff;
  font-size: 34px;
  @media screen and (max-width: 767px) {
    font-size: 30px;
  }
  @media screen and (max-width: 479px) {
    font-size: 24px;
  }
`;

{/* <img src="images/finik9.png" loading="lazy" alt="" className="finik2"/> */}
const Finik2 = styled.img`
  animation: 3s ${keyframes`${fadeInRight}`} ;

  position: absolute;
  left: auto;
  top: auto;
  right: 10vw;
  bottom: 10vh;
  width: 230px;

  @media screen and (max-width: 991px) {  
    width: 210px;
  }


  @media screen and (max-width: 767px) {
    width: 180px;
  }
  @media screen and (max-width: 479px) {
    bottom: 15vh;
    width: 110px;
  }


`;

const Page01 = ({ onNextLevel, messNext } ) => {
  return ( 
		<div className="section-info section-front">
			<div className="content-front w-container">
				<div className="div-block">
					<div className="text-block-front">У меня случилась неприятность и я потерял <KeyText>ключ</KeyText> от своей страны. Надеюсь, ты поможешь мне его отыскать.<br/></div>
          <NextButton classes="button-q w-button" onNextLevel={onNextLevel} messNext="вперёд" />
          </div>
			</div>
      <Finik2 src="images/finik9.png" loading="lazy" alt="Финик"/>
    </div>
      );
}

export default Page01;
